import React from 'react';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import SearchOffRoundedIcon from '@mui/icons-material/SearchOffRounded';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import styles from './LeadsEmptyState.module.css';

/**
 * Funil vazio no período. Com busca ativa, o texto fala da busca; sem busca,
 * explica de onde os leads vêm e oferece o atalho para adicionar.
 */
function LeadsEmptyState({ searching, onAdd }) {
  if (searching) {
    return (
      <div className={styles.empty}>
        <span className={styles.iconSolo}><SearchOffRoundedIcon /></span>
        <span className={styles.title}>Nenhum lead com esse telefone</span>
        <span className={styles.text}>Confira os números digitados ou amplie o período acima.</span>
      </div>
    );
  }

  return (
    <div className={styles.empty}>
      <div className={styles.illustration} aria-hidden="true">
        <span className={`${styles.bubble} ${styles.bubbleLeft}`}><WhatsAppIcon style={{ fontSize: 18 }} /></span>
        <span className={styles.iconMain}><GroupsOutlinedIcon style={{ fontSize: 30 }} /></span>
        <span className={`${styles.bubble} ${styles.bubbleRight}`}><CampaignOutlinedIcon style={{ fontSize: 18 }} /></span>
      </div>
      <span className={styles.title}>Nenhum lead neste período</span>
      <span className={styles.text}>
        Quem chama pelo WhatsApp conectado à Gabriela entra aqui automaticamente. Contatos de outros canais
        você adiciona à mão e acompanha etapa por etapa.
      </span>
      <button type="button" className={styles.action} onClick={onAdd}>
        <AddRoundedIcon style={{ fontSize: 18 }} />
        Adicionar lead
      </button>
    </div>
  );
}

export default LeadsEmptyState;
